import React from "react";
import { useTranslation } from "next-i18next";
import { MeFieldFragment } from "graphql/generated";
import Stack from "@mui/material/Stack";

type NitoelEnv = "prod" | "pre" | "dev" | "local" | "unknown";

export function getNitoelEnv(): NitoelEnv {
  const domain = window.location.hostname;
  switch (domain) {
    case "nitoel.com":
      return "prod";
    case "pre.nitoel.net":
      return "pre";
    case "dev.nitoel.net":
      return "dev";
    case "127.0.0.1":
      return "local";
    case "localhost":
      return "local";
    default:
      return "unknown";
  }
}

type EnvInfoProps = {
  me: MeFieldFragment | null;
};
const EnvInfo: React.FC<EnvInfoProps> = (props) => {
  const { t } = useTranslation(["common"]);
  const { me } = props;
  if (me == null) {
    return null;
  }

  const nitoelEnv = getNitoelEnv();

  // nitoelの人以外には組織情報は見せない
  // nitoelの人以外には本番環境ではなにもみせない
  // nitoelの人には常に全部見せる

  if (!me.isRoot && nitoelEnv !== "prod") {
    return (
      <Stack direction="row" spacing={1}>
        <div>
          {t("common:env")}: {t(`common:envs.${nitoelEnv}`)}
        </div>
      </Stack>
    );
  }

  if (!me.isRoot && nitoelEnv === "prod") {
    return null;
  }

  return (
    <Stack direction="row" spacing={1}>
      <div>
        {t("common:env")}: {t(`common:envs.${nitoelEnv}`)}
      </div>
      <div>
        {t("common:org")}: {me.tenant.name}({me.tenant.code})
      </div>
    </Stack>
  );
};

export default EnvInfo;
